<div class="bg-white shadow-lg px-3 py-1">
  <div class="small-text">
    <div class="d-flex">
      <div class="fw-bold col nameminwidth pe-3">{{ 'HOME_COMPONENTS.LEGEND_CONTROL.TICKET_OWNER' | translate }}</div>
      <div class="fw-bold col-auto">{{ 'HOME_COMPONENTS.LEGEND_CONTROL.QTY' | translate }}</div>
    </div>
    @for (item of userList; track item) {
      <div
        class="divpanel pt-1 d-flex align-items-center justify-content-between w-100"
        >
        <div class="col nameminwidth pe-3">
          <span
            class="dot"
            style="background-color:#{{ item.icon_colour }}"
          ></span>
          {{ item.user_name }}
        </div>
        <div class="col-auto">{{ item.count }}</div>
      </div>
    }
    @for (item of teamList; track item) {
      <div
        class="divpanel pt-1 d-flex align-items-center justify-content-between w-100"
        >
        <div class="col nameminwidth pe-3" kendoTooltip [tooltipTemplate]="tooltipTemplateTeamTechs"
          position="right" [tooltipWidth]="250" title="">
          <ng-template #tooltipTemplateTeamTechs let-anchor>
            @for (tech of item.techs; track tech) {
              <div>{{ tech }}</div>
            }
          </ng-template>
          <span
            class="dot"
            style="background-color:#{{ item.icon_colour }}"
          ></span>
          {{ item.team_title }}
        </div>
        <div class="col-auto">{{ item.count }}</div>
      </div>
    }
  </div>
</div>
